/* eslint-disable padding-line-between-statements */
import React, { useCallback, useContext, useEffect, useState } from 'react'
import _ from 'lodash'
import { BreakpointTrackerContext } from '@jutro/layout';
import { TranslatorContext } from '@jutro/locale';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { ViewModelForm, useDataRefresh, ViewModelServiceContext } from '@xengage/gw-portals-viewmodel-react';

import metadata from './TWIAConstructionDetails.metadata.json5';
import messages from '../Construction.messages';

function TWIAConstructionDetails(props) {
    const { submissionVM, isMSBEligible, updateWizardData, showErrors, findInvalidComponent, steps, onValidate, isRenewal, isEitherChangeOrRenewal } = props;
    const translator = useContext(TranslatorContext);
    const breakpoint = useContext(BreakpointTrackerContext);
    const viewModelService = useContext(ViewModelServiceContext);
    const [yearBuilt, setYearBuilt] = useState(false)
    const [condOfDwelling, setCondOfDwelling] = useState(false)
    const [constType, setConstType] = useState(false)
    const [numOfStories, setNumOfStories] = useState(false)
    const [areaSquare, setAreaSquare] = useState(false)
    const [garage, setGarage] = useState(false)
    const [foundType, setFoundType] = useState(false)
    const[constructionTypeValues, setConstructionTypeValues] = useState([]);
    const policyTypeCode = submissionVM.lobData.homeowners.policyType_TWIA.value.code;
    const { refreshData } = useDataRefresh();
    const structureTypeValue = _.get(submissionVM, 'lobData.homeowners.coverables.yourHome.structureType_TWIA.value');
    const { onValidate: setComponentValidation, isComponentValid } = useValidation('TWIAConstructionDetails');
    const orgConstDate = _.get(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value');
    const model_Year = _.get(submissionVM, 'lobData.homeowners.coverables.construction.mobileHomeModelYear_TWIA.value');
    
    useEffect(() => {
        if (onValidate && !_.isNull(isComponentValid)) {
            onValidate(isComponentValid, 'TWIAConstructionDetails');
        }
    }, [isComponentValid, onValidate]);

    useEffect(() => {
        findInvalidComponent(isComponentValid, 'TWIAConstructionDetails');
    }, [findInvalidComponent, isComponentValid])

    useEffect(() => {
        // DE15498, DE15510, DE18038
        const pageSubmitted = steps.some(step => step.path === '/construction' && step.submitted);
        const yearBuiltValue = _.get(submissionVM, 'lobData.homeowners.coverables.construction.yearBuilt.value')
        //if (_.isEmpty(_.get(submissionVM.value, 'lobData.homeowners.coverables.construction'))){
           
        
            if ((policyTypeCode !== 'TWRM' && !pageSubmitted && orgConstDate === undefined) ||
                (policyTypeCode === 'TWRM' && !pageSubmitted && model_Year === undefined)) {
                // check to see if msbData Exists..
                if (!_.get(submissionVM, 'lobData.homeowners.coverables.construction.msbDataExists_TWIA.value')){
                    _.set(submissionVM, 'lobData.homeowners.coverables.construction.value', {})
                }
               
            }
        if (submissionVM.lobData.homeowners.coverables.construction.structureType_TWIA !== undefined) {
            _.set(submissionVM, 'lobData.homeowners.coverables.construction.structureType_TWIA.value', structureTypeValue)
        } 

        if(yearBuiltValue){
            origConstructionDate()
        }
            setConstructionValues_TWIA();
        //}
    }, [])

    const filterConstructionTypeTWIA = useCallback(() => {
        const availableConstructionType = submissionVM.lobData.homeowners.coverables.construction.constructionType?.aspects.availableValues;
        if (availableConstructionType?.length > 0) {
            const constructionTypeList = availableConstructionType.map((code) => {
                return {
                    code: code.code,
                    name: translator({ id: code.name })
                }

            })
            setConstructionTypeValues(constructionTypeList)
        }
    }, [submissionVM, translator])
    

    const setConstructionValues_TWIA = useCallback(() => {
        const structureType = structureTypeValue.code;
        switch (policyTypeCode) {
            case 'TWRD':
                if (structureType === 'DwellingOutBuild' || structureType === '1Family' || structureType === '2Family'
                    || structureType === 'IndividuallyTH' || structureType === 'PublicHousing') {
                    setYearBuilt(true)
                    setCondOfDwelling(true)
                    setGarage(true)
                    setAreaSquare(true)
                    setConstType(true)
                    setFoundType(true)
                    setNumOfStories(true)
                }
                else if (structureType === 'AntennaDish' || structureType === 'Greenhouse' || structureType === 'SwimmingPool'
                    || structureType === 'MiscStructure') {
                    setYearBuilt(true)
                }
                else if (structureType === 'Boathouse') {
                    setYearBuilt(true)
                    setNumOfStories(true)
                }
                else if (structureType === 'Deck' || structureType === 'Fence') {
                    setYearBuilt(true)
                    setConstType(true)
                }
                break;
            case 'TWRP':
                setYearBuilt(true)
                setConstType(true)
                setAreaSquare(true)
                break;
            case 'TWRC':
                setYearBuilt(true)
                setConstType(true)
                setAreaSquare(true)
                break;
            case 'TWRM':
                setCondOfDwelling(true)
                break;
            default:
        }
        filterConstructionTypeTWIA();
        updateWizardData(submissionVM);
    }, [])
 
    // 2024-07-01 - Debra Frum - DE15551 - Feature Testing_Portals_ PE_TWIA_Res Quote_Year of Original Construction Date field 
    //                                     should be automatically filled in based on "Year Built field in Construction Page
    const origConstructionDate = useCallback(() => {
        // Default year of Original Construction Date to Year Built
        if (submissionVM.lobData.homeowners.coverables.construction.yearBuilt?.value) {
            const yearBuiltValue = _.get(submissionVM, 'lobData.homeowners.coverables.construction.yearBuilt.value')
            const origConstDate = _.get(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value')

            // If Original Construction Date has already been set, only change the year
            if (origConstDate) {
                _.set(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value.year', yearBuiltValue)
                if (yearBuiltValue <= 1980) { // DE18251 - value being persisted when saved for Year Build > 1980 
                    _.set(submissionVM, 'lobData.homeowners.coverables.construction.hasWPI8CertOfCompIssued_TWIA.value', null)
                }
            // If Original Construction Date has not been set yet, set it to the first day of the year
            } else {
                _.set(submissionVM, 'lobData.homeowners.coverables.construction.originalConstDate_TWIA.value', {
                    year: yearBuiltValue,
                    month: '00',
                    day: '01'
                });
            }
        }

        updateWizardData(submissionVM);
    }, [submissionVM, updateWizardData])

    // DE15653
    const [yearMessage, setYearMessage] = useState([]);
    
    const yearChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            setYearMessage([]);

            if (value === '' || value === undefined) {
                setYearMessage([translator(messages.requiredField)])
            }
            else if (value < 1000) {
                setYearMessage([translator(messages.modelYearMessage)])
            } 
            const currentYear = (new Date()).getFullYear();
            if (value > (currentYear)){
                setYearMessage([translator(messages.cannotBeFutureDate)])
            }
            updateWizardData(submissionVM);
        },
        [submissionVM, updateWizardData, translator]);

    // DE17578 issue 1
    const [yearBuiltMessage, setYearBuiltMessage] = useState([]);

    const yearBuiltChange = useCallback(
        (value, path) => {
            _.set(submissionVM, path, value);
            setYearBuiltMessage([]);

            if (value === '' || value === undefined) {
                setYearBuiltMessage([translator(messages.requiredField)])
            }
            const currentYear = (new Date()).getFullYear();
            if (value > (currentYear)) {
                setYearBuiltMessage([translator(messages.cannotBeFutureDate)])
            }
            if (path === 'lobData.homeowners.coverables.construction.yearBuilt') {
                origConstructionDate();
            }
            refreshData();
            updateWizardData(submissionVM);
        },
        [submissionVM, refreshData, updateWizardData, translator, origConstructionDate]);


    const overrideProps = {
        '@field': {
            labelPosition: breakpoint === 'desktop' ? 'left' : 'top',
        },
        yearBuilt: {
            visible: yearBuilt,
            readOnly: (isMSBEligible && policyTypeCode === 'TWRD') || isEitherChangeOrRenewal,
            validationMessages: yearBuiltMessage, // DE17578
        },
        conditionofDwelling: {
            visible: condOfDwelling
        },
        constructionType: {
            visible: constType,
            availableValues: constructionTypeValues,
            readOnly: isMSBEligible && policyTypeCode === 'TWRD'
        },
        numberofStories: {
            visible: numOfStories,
            readOnly: isMSBEligible && policyTypeCode === 'TWRD'
        },
        livingArea: {
            visible: areaSquare,
            readOnly: isMSBEligible && policyTypeCode === 'TWRD'
        },
        Garage: {
            visible: garage,
            readOnly: isMSBEligible && policyTypeCode === 'TWRD'
        },
        foundationType: {
            visible: foundType,
            readOnly: isMSBEligible && policyTypeCode === 'TWRD'
        },
        tieDownReport: {
            visible: policyTypeCode === 'TWRM',
        },
        modelName: {
            readOnly: isEitherChangeOrRenewal
        },
        serialNumber: {
            readOnly: isEitherChangeOrRenewal
        },
        length:{
            readOnly: isEitherChangeOrRenewal
        },
        width: {
            readOnly: isEitherChangeOrRenewal
        },
        modelYear: {
            validationMessages: yearMessage,
            readOnly: isEitherChangeOrRenewal
        },
        windZone: {
            readOnly: isEitherChangeOrRenewal
        }
    }
    const writeValue = useCallback(
        (value, path) => {
            // 2024-07-01 - Debra Frum - DE15551 - Feature Testing_Portals_ PE_TWIA_Res Quote_Year of Original Construction Date field 
            //                                     should be automatically filled in based on "Year Built field in Construction Page
            if (path === 'lobData.homeowners.coverables.construction.yearBuilt') {
                origConstructionDate();
            }
            refreshData();

            _.set(submissionVM, path, value);
            updateWizardData(submissionVM);
            refreshData();
        }, [refreshData, submissionVM, updateWizardData, origConstructionDate]
    );

    const resolvers = {
        resolveCallbackMap: {
            onYearChange: yearChange,
            onYearBuiltChange: yearBuiltChange,
            origConstructionDate
        },
        // resolveClassNameMap: styles
    }

    return (
        <ViewModelForm
            uiProps={metadata.pageContent}
            overrideProps={overrideProps}
            model={submissionVM}
            showErrors={showErrors}
            onValueChange={writeValue}
            onValidationChange={setComponentValidation}
            onModelChange={updateWizardData}
            callbackMap={resolvers.resolveCallbackMap}
            classNameMap={resolvers.resolveClassNameMap}
        />
    )
}

export default TWIAConstructionDetails;